export default {
  getRents: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/rents/getters.js